const getYouTubeVideoLink = (videoId: string): string =>
  `https://youtu.be/${videoId}`

export default getYouTubeVideoLink
